import { gql } from '@apollo/client';

import { supplierDetailsFragment } from '../fragments/supplierFragments.gql';

export const SuppliersPageUpdateSupplierMutation = gql`
  mutation SuppliersPageUpdateSupplier($supplier: SupplierUpdateInput!) {
    supplierUpdate(supplier: $supplier) {
      ...SupplierDetailsFragment
      __typename
    }
  }
  ${supplierDetailsFragment}
`;
